module.exports = __webpack_public_path__ + "static/4-853abc5f3077ef1cf52c0eafde3389fa.png";